var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { useConfirm } from 'material-ui-confirm';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircularProgress from '@mui/material/CircularProgress';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { StyledButton } from 'components/Shared/StyledButton/StyledButton';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { useRef, useState } from 'react';
import { useLoaderData, useParams, useSearchParams } from 'react-router-dom';
import { deleteDraft, getDraft } from 'services/api/engineering-service';
import { handleOptionSave } from 'services/helperFunctions/handleOptionSave';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { noSpaces, noSpacesAll } from 'services/helperFunctions/handleRegex';
import { DeleteDraftRequest, EngineeringFeature, } from '@millerknoll/pub-api-schema';
import { useCheckAuthScope } from 'services/helperFunctions/useCheckAuthScope';
import { useLanguageCode } from 'services/helperFunctions/useLanguageCode';
import { UI_WRITE_SCOPES } from 'utils/constants';
import { TableDataRowOption } from './TableDataRowOption/TableDataRowOption';
import { FeatureRules } from './FeatureRules/FeatureRules';
import styles from './TableDataRow.module.scss';
export function TableDataRow(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var index = _a.index, feature = _a.feature, isEditable = _a.isEditable, handleDelete = _a.handleDelete, togglePublish = _a.togglePublish, productFeaturesMap = _a.productFeaturesMap, injectInfoIntoModal = _a.injectInfoIntoModal;
    var languageCode = useLanguageCode();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var tableRowRef = useRef(null);
    var params = useParams();
    var productId = params === null || params === void 0 ? void 0 : params.productId;
    var searchParams = useSearchParams()[0];
    var processingDate = (_b = searchParams.get('processingDate')) !== null && _b !== void 0 ? _b : undefined;
    var confirm = useConfirm();
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var loaderData = useLoaderData();
    var productVersion = (_d = ((_c = loaderData.details) === null || _c === void 0 ? void 0 : _c.metadata).productVersion) !== null && _d !== void 0 ? _d : ((_e = loaderData.details) === null || _e === void 0 ? void 0 : _e.header).productVersion;
    var userHasEditPrivileges = useCheckAuthScope(UI_WRITE_SCOPES);
    var featureId = feature.featureId;
    var _o = useState(false), isExpanded = _o[0], setIsExpanded = _o[1];
    var _p = useState(), featureOptionsArray = _p[0], setFeatureOptionsArray = _p[1];
    var _q = useState(), featureOptionsObject = _q[0], setFeatureOptionsObject = _q[1];
    var _r = useState((_f = feature.mfgMdlCd) !== null && _f !== void 0 ? _f : ''), mFeatureModelCode = _r[0], setMFeatureModelCode = _r[1];
    var _s = useState((_g = feature.prcMdlCd) !== null && _g !== void 0 ? _g : ''), pFeatureModelCode = _s[0], setPFeatureModelCode = _s[1];
    var _t = useState((_h = feature.mtrlCd) !== null && _h !== void 0 ? _h : ''), materialCode = _t[0], setMaterialCode = _t[1];
    var _u = useState(false), inputFieldChange = _u[0], setInputFieldChange = _u[1];
    var _v = useState(false), expandedDataLoading = _v[0], setExpandedDataLoading = _v[1];
    var _w = useState(false), mfgOverrideLoading = _w[0], setMfgOverrideLoading = _w[1];
    var _x = useState((_l = (_k = (_j = feature === null || feature === void 0 ? void 0 : feature.desc) === null || _j === void 0 ? void 0 : _j["".concat(languageCode)]) === null || _k === void 0 ? void 0 : _k.desc) !== null && _l !== void 0 ? _l : ''), featureDescription = _x[0], setFeatureDescription = _x[1];
    var _y = useState(feature), featureData = _y[0], setFeatureData = _y[1];
    var _z = useState(false), isCopying = _z[0], setIsCopying = _z[1];
    var _0 = useState(false), isDeleting = _0[0], setIsDeleting = _0[1];
    var _1 = useState(5), ruleLimit = _1[0], setRuleLimit = _1[1];
    var _2 = useState(), dependencyRulesMap = _2[0], setDependencyRulesMap = _2[1];
    var handleCopyButtonClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, dataToInject;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(isEditable && productId)) return [3 /*break*/, 2];
                    setIsCopying(function (prevVal) { return !prevVal; });
                    return [4 /*yield*/, getDraft({ productId: productId, featureId: featureId, processingDate: processingDate })];
                case 1:
                    data = _b.sent();
                    dataToInject = (_a = data.details) === null || _a === void 0 ? void 0 : _a.feature;
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    injectInfoIntoModal(dataToInject);
                    setIsCopying(function (prevVal) { return !prevVal; });
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleMfgOverrideDraft = function (id, mFeatureModeCode) { return __awaiter(_this, void 0, void 0, function () {
        var dataForFeature, type_1, step_1, totalDataForProduct, featuresToOverRide;
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!productId) return [3 /*break*/, 3];
                    setMfgOverrideLoading(true);
                    return [4 /*yield*/, getDraft({ productId: productId, featureId: id, processingDate: processingDate })];
                case 1:
                    dataForFeature = _g.sent();
                    type_1 = (_b = (_a = dataForFeature === null || dataForFeature === void 0 ? void 0 : dataForFeature.details) === null || _a === void 0 ? void 0 : _a.feature) === null || _b === void 0 ? void 0 : _b.type;
                    step_1 = (_d = (_c = dataForFeature === null || dataForFeature === void 0 ? void 0 : dataForFeature.details) === null || _c === void 0 ? void 0 : _c.feature) === null || _d === void 0 ? void 0 : _d.step;
                    return [4 /*yield*/, getDraft({ productId: productId, processingDate: processingDate })];
                case 2:
                    totalDataForProduct = _g.sent();
                    featuresToOverRide = (_f = (_e = totalDataForProduct.details) === null || _e === void 0 ? void 0 : _e.features) === null || _f === void 0 ? void 0 : _f.filter(function (featureValue) { return featureValue.step === step_1 && featureValue.type === type_1; });
                    featuresToOverRide === null || featuresToOverRide === void 0 ? void 0 : featuresToOverRide.forEach(function (featureToOverride) { return __awaiter(_this, void 0, void 0, function () {
                        var currentFeatureDraftData;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, getDraft({
                                        productId: productId,
                                        featureId: featureToOverride.featureId,
                                        processingDate: processingDate,
                                    })];
                                case 1:
                                    currentFeatureDraftData = _b.sent();
                                    return [4 /*yield*/, handleSaveDraft(mFeatureModeCode, 'mFeatureModelCode', (_a = currentFeatureDraftData.details) === null || _a === void 0 ? void 0 : _a.feature)];
                                case 2:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    setMfgOverrideLoading(false);
                    setSnackbarAlert({
                        message: "Manufacture Model Code updated for all features with featureId - ".concat(featureId, ", type - ").concat(type_1, ", step - ").concat(step_1),
                        type: 'success',
                    });
                    _g.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteFeatureButtonClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            if (isEditable && productId) {
                confirm({ title: "Are you sure you want to delete feature '".concat(featureId, "' - ").concat(featureDescription, "?") })
                    .then(function () { return __awaiter(_this, void 0, void 0, function () {
                    var response;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                setIsDeleting(true);
                                return [4 /*yield*/, deleteDraft({
                                        productId: productId,
                                        featureId: featureId,
                                        productVersion: productVersion,
                                        status: DeleteDraftRequest.status.DRAFT,
                                    })];
                            case 1:
                                response = _b.sent();
                                if (response.status !== 200) {
                                    setSnackbarAlert({
                                        message: (_a = response.body.message) !== null && _a !== void 0 ? _a : '',
                                        type: 'error',
                                    });
                                    setIsDeleting(false);
                                }
                                else {
                                    setSnackbarAlert({
                                        message: "Deleted feature with ID '".concat(featureId, "'"),
                                        type: 'success',
                                    });
                                    setIsDeleting(false);
                                    handleDelete(featureId);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); })
                    .catch(function () {
                    setIsDeleting(false);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var handleInputFieldChange = function (fnc, event) {
        if (isEditable && userHasEditPrivileges) {
            setInputFieldChange(true);
            fnc(event.target.value);
        }
    };
    var turnOptionsIntoArray = function (options) {
        var arrayifiedOptions = Object.entries(options);
        arrayifiedOptions.forEach(function (o) {
            Object.assign(o[1], { optionCode: o[0] });
        });
        setFeatureOptionsObject(options);
        setFeatureOptionsArray(arrayifiedOptions);
    };
    // eslint-disable-next-line consistent-return
    var getDraftData = function (id, level) { return __awaiter(_this, void 0, void 0, function () {
        var data, keysArray, options, feat, depRuleMap;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    if (!productId) return [3 /*break*/, 2];
                    return [4 /*yield*/, getDraft({ productId: productId, featureId: id, processingDate: processingDate })];
                case 1:
                    data = _m.sent();
                    keysArray = Object.keys((_a = data.details) === null || _a === void 0 ? void 0 : _a.feature);
                    if (keysArray.includes('options')) {
                        options = (_c = (_b = data.details) === null || _b === void 0 ? void 0 : _b.feature) === null || _c === void 0 ? void 0 : _c.options;
                        if (options) {
                            turnOptionsIntoArray(options);
                        }
                    }
                    feat = (_d = data.details) === null || _d === void 0 ? void 0 : _d.feature;
                    if (level !== '1') {
                        setMaterialCode((_e = feat === null || feat === void 0 ? void 0 : feat.mtrlCd) !== null && _e !== void 0 ? _e : '');
                        setMFeatureModelCode((_f = feat === null || feat === void 0 ? void 0 : feat.mfgMdlCd) !== null && _f !== void 0 ? _f : '');
                        setPFeatureModelCode((_g = feat === null || feat === void 0 ? void 0 : feat.prcMdlCd) !== null && _g !== void 0 ? _g : '');
                        setIsExpanded(function (prevVal) { return !prevVal; });
                        setExpandedDataLoading(function (prevVal) { return !prevVal; });
                    }
                    setFeatureData((_h = data.details) === null || _h === void 0 ? void 0 : _h.feature);
                    depRuleMap = (_k = (_j = data === null || data === void 0 ? void 0 : data.details) === null || _j === void 0 ? void 0 : _j.feature) === null || _k === void 0 ? void 0 : _k.depRules;
                    setDependencyRulesMap(depRuleMap !== null && depRuleMap !== void 0 ? depRuleMap : {});
                    return [2 /*return*/, (_l = data.details) === null || _l === void 0 ? void 0 : _l.feature];
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleFeatureTableRowExpand = function (id) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (productId && !isExpanded) {
                setExpandedDataLoading(function (prevVal) { return !prevVal; });
                getDraftData(id, '2');
            }
            else {
                setIsExpanded(function (prevVal) { return !prevVal; });
                setRuleLimit(5);
            }
            return [2 /*return*/];
        });
    }); };
    var handleTopLevelFeatureFieldChangeAndBlur = function (newVal, param) { return __awaiter(_this, void 0, void 0, function () {
        var featureWithModifiedDescription, featData, keysArray, options, response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!userHasEditPrivileges)
                        return [2 /*return*/, undefined];
                    setInputFieldChange(true);
                    if (!(productId && featureId)) return [3 /*break*/, 5];
                    featureWithModifiedDescription = void 0;
                    if (!(param === 'description')) return [3 /*break*/, 2];
                    return [4 /*yield*/, getDraftData(featureId, '1')];
                case 1:
                    featData = _c.sent();
                    if (featData &&
                        featData.desc &&
                        ((_a = featData.desc) === null || _a === void 0 ? void 0 : _a["".concat(languageCode)]) &&
                        newVal !== ((_b = featData === null || featData === void 0 ? void 0 : featData.desc) === null || _b === void 0 ? void 0 : _b["".concat(languageCode)].desc)) {
                        featData.desc["".concat(languageCode)].desc = newVal.trim();
                        featureWithModifiedDescription = featData;
                    }
                    return [3 /*break*/, 3];
                case 2:
                    if (param === 'mFeatureModelCode') {
                        featureData.mfgMdlCd = newVal;
                    }
                    else if (param === 'pFeatureModelCode') {
                        featureData.prcMdlCd = newVal;
                    }
                    else if (param === 'materialCode') {
                        featureData.mtrlCd = newVal;
                    }
                    _c.label = 3;
                case 3:
                    keysArray = Object.keys(featureData);
                    if (keysArray.includes('options')) {
                        options = featureData.options;
                        if (options) {
                            turnOptionsIntoArray(options);
                        }
                    }
                    return [4 /*yield*/, handleOptionSave(isEditable, featureWithModifiedDescription ? featureWithModifiedDescription.options : featureData.options, productId, productVersion !== null && productVersion !== void 0 ? productVersion : '', featureWithModifiedDescription !== null && featureWithModifiedDescription !== void 0 ? featureWithModifiedDescription : featureData)];
                case 4:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 5: return [2 /*return*/, undefined];
            }
        });
    }); };
    var handleSaveDraft = function (newVal, param, detailFeature) { return __awaiter(_this, void 0, void 0, function () {
        var featureWithModifiedDescription, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!userHasEditPrivileges)
                        return [2 /*return*/, undefined];
                    setInputFieldChange(true);
                    if (!(productId && detailFeature)) return [3 /*break*/, 2];
                    featureWithModifiedDescription = void 0;
                    if (param === 'mFeatureModelCode') {
                        detailFeature.mfgMdlCd = newVal;
                    }
                    return [4 /*yield*/, handleOptionSave(isEditable, featureWithModifiedDescription === null || featureWithModifiedDescription === void 0 ? void 0 : featureWithModifiedDescription.options, productId, productVersion !== null && productVersion !== void 0 ? productVersion : '', featureWithModifiedDescription !== null && featureWithModifiedDescription !== void 0 ? featureWithModifiedDescription : detailFeature)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2: return [2 /*return*/, undefined];
            }
        });
    }); };
    var handleAddRulesButtonClick = function () {
        setRuleLimit(function (prevVal) { return prevVal + 25; });
    };
    var handleRemoveCircleIcon = function () {
        setRuleLimit(5);
        tableRowRef.current.scrollIntoView();
    };
    var getModelCodeErrorLabel = function (value, spaceMessage) {
        if (!noSpaces(value))
            return spaceMessage;
        if (value.length > 80)
            return 'Must be 80 characters or fewer';
        return '';
    };
    var hasModelCodeError = function (value) { return !noSpaces(value) || value.length > 80; };
    return (_jsxs(_Fragment, { children: [_jsxs(TableRow, __assign({ ref: tableRowRef, sx: {
                    '&.MuiTableRow-root:hover': {
                        backgroundColor: 'rgba(0, 255, 0, 0.1)',
                    },
                    backgroundColor: index % 2 === 0 ? 'rgba(0, 0, 0, 0.1)' : 'white',
                }, hover: true }, { children: [_jsx(TableCell, __assign({ scope: "row", className: styles.tableCell }, { children: _jsx(Typography, { children: feature.step }) })), _jsx(TableCell, __assign({ scope: "row", className: styles.tableCell, width: "8%" }, { children: _jsx(Typography, { children: feature.type }) })), _jsxs(TableCell, __assign({ className: styles.descriptionAndIconsContainer }, { children: [feature.type !== EngineeringFeature.type.IMPLIED ? (_jsx(Typography, __assign({ sx: { alignSelf: 'center' } }, { children: (_m = feature.desc) === null || _m === void 0 ? void 0 : _m["".concat(languageCode)].desc }))) : (_jsx(TextField, { size: "small", value: featureDescription !== null && featureDescription !== void 0 ? featureDescription : '', onChange: function (e) {
                                    if (feature.type === EngineeringFeature.type.IMPLIED) {
                                        handleInputFieldChange(setFeatureDescription, e);
                                    }
                                    else if (userHasEditPrivileges) {
                                        setSnackbarAlert({
                                            message: 'Editing for Base/NonBase Feature Description disabled',
                                            type: 'error',
                                        });
                                    }
                                }, onBlur: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                if (!(featureDescription &&
                                                    noSpacesAll(featureDescription) &&
                                                    inputFieldChange &&
                                                    featureDescription !== ((_a = feature.desc) === null || _a === void 0 ? void 0 : _a["".concat(languageCode)].desc))) return [3 /*break*/, 2];
                                                return [4 /*yield*/, handleTopLevelFeatureFieldChangeAndBlur(featureDescription, 'description')];
                                            case 1:
                                                response = _b.sent();
                                                if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                                                    setSnackbarAlert({
                                                        message: (response === null || response === void 0 ? void 0 : response.body).message || '',
                                                        type: 'error',
                                                    });
                                                }
                                                else {
                                                    setSnackbarAlert({
                                                        message: "Feature Description saved",
                                                        type: 'success',
                                                    });
                                                }
                                                setInputFieldChange(false);
                                                _b.label = 2;
                                            case 2: return [2 /*return*/];
                                        }
                                    });
                                }); }, fullWidth: true, error: !noSpacesAll(featureDescription !== null && featureDescription !== void 0 ? featureDescription : ''), label: !noSpacesAll(featureDescription !== null && featureDescription !== void 0 ? featureDescription : '') ? 'Value cannot be empty' : '', disabled: !userHasEditPrivileges || !isEditable })), feature.type === 'Implied' && isEditable && (_jsx(Box, __assign({ hidden: !userHasEditPrivileges }, { children: _jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'row' } }, { children: [!isCopying ? (_jsx(IconButton, __assign({ onClick: function () { return handleCopyButtonClick(); }, className: styles.copyButton }, { children: _jsx(ContentCopyIcon, {}) }))) : (_jsx(IconButton, __assign({ className: styles.copyButton }, { children: _jsx(CircularProgress, { size: "1.5rem" }) }))), !isDeleting ? (_jsx(IconButton, __assign({ onClick: function () { return handleDeleteFeatureButtonClick(); }, className: styles.copyButton }, { children: _jsx(DeleteIcon, {}) }))) : (_jsx(IconButton, __assign({ className: styles.copyButton }, { children: _jsx(CircularProgress, { size: "1.5rem" }) })))] })) }))), _jsx(Box, __assign({ sx: { marginLeft: 'auto' } }, { children: !expandedDataLoading ? (_jsxs(IconButton, __assign({ onClick: function () { return handleFeatureTableRowExpand(feature.featureId); }, className: styles.copyButton }, { children: [!expandedDataLoading && !isExpanded && _jsx(KeyboardArrowDownIcon, {}), isExpanded && !expandedDataLoading && _jsx(KeyboardArrowUpIcon, {})] }))) : (_jsx(IconButton, __assign({ className: styles.copyButton }, { children: _jsx(CircularProgress, { size: "1.5rem" }) }))) }))] }))] }), feature.featureId), isExpanded && (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: 3 }, { children: _jsxs(Collapse, __assign({ in: isExpanded, className: styles.collapse }, { children: [_jsxs(Box, __assign({ className: styles.topLevelFieldContainer }, { children: [_jsx(Typography, __assign({ className: styles.featureIdLabel }, { children: "Feature Id:" })), _jsx(Typography, __assign({ className: styles.featureIdValue }, { children: featureId }))] })), dependencyRulesMap && Object.entries(dependencyRulesMap).length > 0 && (_jsx(FeatureRules, { arrayOfDependencyRules: dependencyRulesMap, ruleLimit: ruleLimit, productFeaturesMap: productFeaturesMap, handleRemoveRulesFromChild: handleRemoveCircleIcon, handleAddRulesFromChild: handleAddRulesButtonClick })), _jsxs(Box, __assign({ className: styles.topLevelFieldContainer }, { children: [mfgOverrideLoading && _jsx(LoadingSpinner, { indicatorSize: 5 }), _jsx(Typography, __assign({ className: styles.mfgLabel }, { children: "Manufacturing Feature Model Code:" })), _jsx(TextField, { size: "small", value: mFeatureModelCode !== null && mFeatureModelCode !== void 0 ? mFeatureModelCode : '', onChange: function (e) { return handleInputFieldChange(setMFeatureModelCode, e); }, onBlur: function () { return __awaiter(_this, void 0, void 0, function () {
                                            var response;
                                            var _a, _b, _c;
                                            return __generator(this, function (_d) {
                                                switch (_d.label) {
                                                    case 0:
                                                        if (!(noSpaces(mFeatureModelCode) &&
                                                            mFeatureModelCode.length <= 80 &&
                                                            inputFieldChange &&
                                                            mFeatureModelCode.trim() !== ((_b = (_a = featureData === null || featureData === void 0 ? void 0 : featureData.mfgMdlCd) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''))) return [3 /*break*/, 2];
                                                        return [4 /*yield*/, handleTopLevelFeatureFieldChangeAndBlur(mFeatureModelCode, 'mFeatureModelCode')];
                                                    case 1:
                                                        response = _d.sent();
                                                        if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                                                            setSnackbarAlert({
                                                                message: ((_c = response === null || response === void 0 ? void 0 : response.body) === null || _c === void 0 ? void 0 : _c.message) || '',
                                                                type: 'error',
                                                            });
                                                        }
                                                        else {
                                                            setSnackbarAlert({
                                                                message: "Manufacturing Feature Model Code saved",
                                                                type: 'success',
                                                            });
                                                        }
                                                        setInputFieldChange(false);
                                                        _d.label = 2;
                                                    case 2: return [2 /*return*/];
                                                }
                                            });
                                        }); }, fullWidth: true, error: hasModelCodeError(mFeatureModelCode), label: getModelCodeErrorLabel(mFeatureModelCode, 'Value cannot contain spaces - will not overwrite'), disabled: !userHasEditPrivileges || !isEditable })] })), _jsx(Box, { children: _jsx(StyledButton, { labelText: "Model Code Override", buttonAction: function () {
                                        handleMfgOverrideDraft(feature.featureId, mFeatureModelCode);
                                    }, disabled: !userHasEditPrivileges ||
                                        !isEditable ||
                                        feature.type === EngineeringFeature.type.IMPLIED }) }), _jsxs(Box, __assign({ className: styles.topLevelFieldContainer }, { children: [_jsx(Typography, __assign({ className: styles.prcLabel }, { children: "Price Feature Model Code:" })), _jsx(TextField, { size: "small", value: pFeatureModelCode !== null && pFeatureModelCode !== void 0 ? pFeatureModelCode : '', onChange: function (e) { return handleInputFieldChange(setPFeatureModelCode, e); }, onBlur: function () { return __awaiter(_this, void 0, void 0, function () {
                                            var response;
                                            var _a, _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        if (!(noSpaces(pFeatureModelCode) &&
                                                            pFeatureModelCode.length <= 80 &&
                                                            inputFieldChange &&
                                                            pFeatureModelCode.trim() !== ((_b = (_a = featureData === null || featureData === void 0 ? void 0 : featureData.prcMdlCd) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''))) return [3 /*break*/, 2];
                                                        return [4 /*yield*/, handleTopLevelFeatureFieldChangeAndBlur(pFeatureModelCode, 'pFeatureModelCode')];
                                                    case 1:
                                                        response = _c.sent();
                                                        if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                                                            setSnackbarAlert({
                                                                message: (response === null || response === void 0 ? void 0 : response.body).message || '',
                                                                type: 'error',
                                                            });
                                                        }
                                                        else {
                                                            setSnackbarAlert({
                                                                message: "Price Feature Model Code saved",
                                                                type: 'success',
                                                            });
                                                        }
                                                        setInputFieldChange(false);
                                                        _c.label = 2;
                                                    case 2: return [2 /*return*/];
                                                }
                                            });
                                        }); }, fullWidth: true, error: hasModelCodeError(pFeatureModelCode), label: getModelCodeErrorLabel(pFeatureModelCode, 'Value cannot contain spaces - will not overwrite'), disabled: !userHasEditPrivileges || !isEditable })] })), _jsxs(Box, __assign({ className: styles.topLevelFieldContainer }, { children: [_jsx(Typography, __assign({ className: styles.materialCodeLabel }, { children: "Material Code:" })), _jsx(TextField, { size: "small", value: materialCode !== null && materialCode !== void 0 ? materialCode : '', onChange: function (e) { return handleInputFieldChange(setMaterialCode, e); }, onBlur: function () { return __awaiter(_this, void 0, void 0, function () {
                                            var response;
                                            var _a, _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        if (!(noSpaces(materialCode) &&
                                                            materialCode.length <= 80 &&
                                                            inputFieldChange &&
                                                            materialCode.trim() !== ((_b = (_a = featureData === null || featureData === void 0 ? void 0 : featureData.mtrlCd) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''))) return [3 /*break*/, 2];
                                                        return [4 /*yield*/, handleTopLevelFeatureFieldChangeAndBlur(materialCode, 'materialCode')];
                                                    case 1:
                                                        response = _c.sent();
                                                        if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                                                            setSnackbarAlert({
                                                                message: (response === null || response === void 0 ? void 0 : response.body).message || '',
                                                                type: 'error',
                                                            });
                                                        }
                                                        else {
                                                            setSnackbarAlert({
                                                                message: "Material Code saved",
                                                                type: 'success',
                                                            });
                                                        }
                                                        setInputFieldChange(false);
                                                        _c.label = 2;
                                                    case 2: return [2 /*return*/];
                                                }
                                            });
                                        }); }, fullWidth: true, error: hasModelCodeError(materialCode), label: getModelCodeErrorLabel(materialCode, 'Value cannot contain - will not overwrite'), disabled: !userHasEditPrivileges || !isEditable })] })), _jsx("hr", { className: styles.horizontalRule }), featureOptionsArray ? (featureOptionsArray === null || featureOptionsArray === void 0 ? void 0 : featureOptionsArray.map(function (option) {
                                var _a;
                                return (_jsx(TableDataRowOption, { isEditable: isEditable, optionsData: featureOptionsObject, optionCode: (_a = option[0]) !== null && _a !== void 0 ? _a : '', data: featureData, option: option, royalties: option[1].royalties, handleTogglePublish: togglePublish }, option[0]));
                            })) : (_jsx(TableDataRowOption, { isEditable: isEditable, optionsData: featureOptionsObject, optionCode: "", data: featureData, handleTogglePublish: togglePublish }))] })) })) }))] }));
}
